<template>
  <template v-if="hasCallToAction">
    <button
      type="button"
      class="inline-flex items-center gap-x-2 rounded-full px-4 py-2 text-sm font-semibold shadow-xs cursor-pointer transition-opacity hover:opacity-90"
      :style="{ backgroundColor: callToActionColour, color: callToActionTextColour }"
      @click="openDrawer">
      <i class="fa-sharp fa-solid fa-sparkles fa-fw" aria-hidden="true"></i>
      {{ callToAction }}
    </button>

    <NtAiAssistantDrawer />
  </template>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { useAiAssistantStore } from '@/stores/aiAssistant'
import NtAiAssistantDrawer from '../partials/ai-assistants/NtAiAssistantDrawer.vue'

export default {
  components: { NtAiAssistantDrawer },
  computed: {
    ...mapState(useAiAssistantStore, [
      'hasCallToAction',
      'callToAction',
      'callToActionColour',
      'callToActionTextColour'
    ])
  },
  methods: {
    ...mapActions(useAiAssistantStore, ['openDrawer'])
  }
}
</script>
